import { useState } from "react";

import { Agent, InvestmentProposalApprovedWithRecommendationsResponse } from "@/api/generated";
import { PropallyApiFactory } from "@/module/CustomApiFactory";

interface UseApproveInvestmentProposal {
  approveInvestmentProposal: (id: number) => Promise<{ ok: boolean; additionalAgents: Agent[] }>;
  loading: boolean;
  error: string;
}

export const useApproveInvestmentProposal = (): UseApproveInvestmentProposal => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fp = PropallyApiFactory();

  const approveInvestmentProposal = async (id: number): Promise<{ ok: boolean; additionalAgents: Agent[] }> => {
    setLoading(true);
    setError("");

    try {
      const res = await fp.v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(
        id,
        { is_approved: true },
        { withCredentials: true }
      );
      const responseData: InvestmentProposalApprovedWithRecommendationsResponse = res.data;
      const additionalAgents = Array.isArray(responseData?.recommend_agents) ? responseData.recommend_agents : [];
      return { ok: res.status === 200, additionalAgents };
    } catch (e: any) {
      console.error(e);
      setError(e?.message || "不明なエラー");
      return { ok: false, additionalAgents: [] };
    } finally {
      setLoading(false);
    }
  };

  return { approveInvestmentProposal, loading, error };
};
